import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=090f1d9c&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
import style0 from "./Principal.vue?vue&type=style&index=0&id=090f1d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f1d9c",
  null
  
)

export default component.exports